import { Amplify } from 'aws-amplify';
import NotificationsProvider from 'context/NotificationContext';
import SensorsProvider from 'context/SensorsContext';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import {
  PAGE_CAMERA_SENSOR_LIST,
  PAGE_CREATE_SENSOR,
  PAGE_FLOOD_GATE_SENSOR_LIST,
  PAGE_FLOOD_SENSOR_LIST,
  PAGE_GENERAL_SENSOR_LIST,
  PAGE_MAP,
  PAGE_MASTER_MANAGEMENT,
  PAGE_MODIFY_SENSOR,
  PAGE_PROFILE,
  PAGE_SENSOR_MANAGEMENT,
  PAGE_USER_MANAGEMENT,
  PAGE_VIEW_SENSOR
} from 'utils/constanst';
import './App.css';
import awsconfig from './amplifyconfiguration.json';
import AuthProvider from './context/AuthContext';
import DialogProvider from './context/DialogContext';
import GeneralSettingProvider from './context/GeneralSettingContext';
import SensorGroupsProvider from './context/SensorGroupsContext';
import LoginPage from './pages/Login/LoginPage';
import PageWrapper from './pages/PageWrapper';

Amplify.configure(awsconfig);

function App() {
  /**** States and Variables ****/
  /**** Event Handlers ****/
  /**** Main Render *****/
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path=''
            element={
              <AuthProvider>
                <GeneralSettingProvider>
                  <NotificationsProvider>
                    <SensorGroupsProvider>
                      <SensorsProvider>
                        <DialogProvider>
                          <Outlet />
                        </DialogProvider>
                      </SensorsProvider>
                    </SensorGroupsProvider>
                  </NotificationsProvider>
                </GeneralSettingProvider>
              </AuthProvider>
            }
          >
            <Route path='/' element={<PageWrapper topPage={PAGE_MAP} />} />
            <Route path='/device-management' element={<PageWrapper topPage={PAGE_SENSOR_MANAGEMENT} />} />
            <Route path='/user-management' element={<PageWrapper topPage={PAGE_USER_MANAGEMENT} />} />
            <Route path='/master-management' element={<PageWrapper topPage={PAGE_MASTER_MANAGEMENT} />} />
            <Route path='/list-flood-sensor' element={<PageWrapper topPage={PAGE_FLOOD_SENSOR_LIST} />} />
            <Route path='/list-camera-sensor' element={<PageWrapper topPage={PAGE_CAMERA_SENSOR_LIST} />} />
            <Route path='/list-flood-gate-sensor' element={<PageWrapper topPage={PAGE_FLOOD_GATE_SENSOR_LIST} />} />
            <Route path='/list-general-sensor' element={<PageWrapper topPage={PAGE_GENERAL_SENSOR_LIST} />} />
            <Route path='/profile' element={<PageWrapper topPage={PAGE_PROFILE} />} />
            <Route path='/view-sensor/:id' element={<PageWrapper topPage={PAGE_VIEW_SENSOR} />} />
            <Route path='/modify-sensor/:id' element={<PageWrapper topPage={PAGE_MODIFY_SENSOR} />} />
            <Route path='/create-sensor' element={<PageWrapper topPage={PAGE_CREATE_SENSOR} />} />
          </Route>
          <Route path='*' element={
            <GeneralSettingProvider>
              <LoginPage />
            </GeneralSettingProvider>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
